import type { ReactNode } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select';

type InsightMetric = 'lead_time' | 'sales';

interface Props {
  value: InsightMetric;
  onChange: (value: InsightMetric) => void;
  /** カード内に表示するタイトル・数値などの左側コンテンツ */
  children: ReactNode;
}

/**
 * インサイトタブ上部の指標切り替えカード。
 * カード（高さ113px・幅750px）自体を Select のトリガーにすることで、
 * 右端のシェブロン・カード幅いっぱいのメニュー・既存 Select と同じ開閉挙動を実現する。
 */
export default function InsightMetricSelect({ value, onChange, children }: Props) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as InsightMetric)}>
      <SelectTrigger
        aria-label="表示指標を切り替え"
        className="h-[113px]! w-[750px]! max-w-full overflow-clip rounded-sm border-y-0! border-r-0! border-l-4! border-solid! border-primary! bg-white px-xl! py-sm shadow-layer1 focus-visible:outline-hidden! data-[state=open]:outline-hidden!"
      >
        {children}
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="sales">売上合計</SelectItem>
        <SelectItem value="lead_time">リードタイム</SelectItem>
      </SelectContent>
    </Select>
  );
}
